import(/* webpackMode: "eager" */ "/home/runner/work/web.drivingzone-training/web.drivingzone-training/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web.drivingzone-training/web.drivingzone-training/node_modules/next/dist/client/image-component.js");
